/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { TossPaymentsService } from './services/toss-payments.service';
import { LpInspectionService } from './services/lp-inspection.service';
import { TokenService } from './services/token.service';
import { PointService } from './services/point.service';
import { CenterLogService } from './services/center-log.service';
import { CouponService } from './services/coupon.service';
import { UserService } from './services/user.service';
import { AdminService } from './services/admin.service';
import { OAuthService } from './services/o-auth.service';
import { GoogleService } from './services/google.service';
import { KakaoService } from './services/kakao.service';
import { NaverService } from './services/naver.service';
import { AppleService } from './services/apple.service';
import { StorageService } from './services/storage.service';
import { SettingService } from './services/setting.service';
import { UserProductService } from './services/user-product.service';
import { ProductService } from './services/product.service';
import { ProductCategoryService } from './services/product-category.service';
import { ShoppingCartService } from './services/shopping-cart.service';
import { ProductPurchaseService } from './services/product-purchase.service';
import { AbnormalPaymentService } from './services/abnormal-payment.service';
import { HealthCheckService } from './services/health-check.service';
import { InfoService } from './services/info.service';
import { VoucherService } from './services/voucher.service';
import { EnrollmentService } from './services/enrollment.service';
import { TicketService } from './services/ticket.service';
import { TicketTypeService } from './services/ticket-type.service';
import { TicketSubsidyService } from './services/ticket-subsidy.service';
import { UserActionLogService } from './services/user-action-log.service';
import { GuardianService } from './services/guardian.service';
import { NotificationService } from './services/notification.service';
import { CenterTransactionService } from './services/center-transaction.service';
import { CenterSalaryService } from './services/center-salary.service';
import { CenterService } from './services/center.service';
import { CenterUserService } from './services/center-user.service';
import { CenterRoleService } from './services/center-role.service';
import { CenterGroupService } from './services/center-group.service';
import { CenterNoticeService } from './services/center-notice.service';
import { CenterStatService } from './services/center-stat.service';
import { CenterInviteLogService } from './services/center-invite-log.service';
import { SubscribeService } from './services/subscribe.service';
import { OrderService } from './services/order.service';
import { ChildService } from './services/child.service';
import { ChildMemoService } from './services/child-memo.service';
import { CenterChildService } from './services/center-child.service';
import { LogService } from './services/log.service';
import { CenterJoinLogService } from './services/center-join-log.service';
import { InquiryService } from './services/inquiry.service';
import { FaqService } from './services/faq.service';
import { ParentProfileService } from './services/parent-profile.service';
import { ExcelService } from './services/excel.service';
import { LpInspectionCouponService } from './services/lp-inspection-coupon.service';
import { NoticeService } from './services/notice.service';
import { AdService } from './services/ad.service';
import { AppVersionService } from './services/app-version.service';
import { MemoService } from './services/memo.service';
import { DevelopmentStageService } from './services/development-stage.service';
import { DiaryService } from './services/diary.service';
import { EnrollmentScheduleService } from './services/enrollment-schedule.service';
import { EnrollmentScheduleGroupService } from './services/enrollment-schedule-group.service';
import { AllScheduleService } from './services/all-schedule.service';
import { ScheduleLogService } from './services/schedule-log.service';
import { ScheduleService } from './services/schedule.service';
import { KeywordService } from './services/keyword.service';
import { TagService } from './services/tag.service';
import { ContentService } from './services/content.service';
import { ContentCategoryService } from './services/content-category.service';
import { ContentFavoriteService } from './services/content-favorite.service';
import { UrlService } from './services/url.service';
import { PopupService } from './services/popup.service';
import { InspectionDataService } from './services/inspection-data.service';
import { UserSettingService } from './services/user-setting.service';
import { GrowthCenterService } from './services/growth-center.service';
import { ReceiptService } from './services/receipt.service';
import { DownloadProgressService } from './services/download-progress.service';
import { LpInspectionResultService } from './services/lp-inspection-result.service';
import { PaymentService } from './services/payment.service';
import { TeacherPaymentService } from './services/teacher-payment.service';
import { ParentPaymentService } from './services/parent-payment.service';
import { RefundOrderService } from './services/refund-order.service';
import { KakaoTalkBizMessageService } from './services/kakao-talk-biz-message.service';
import { PdfService } from './services/pdf.service';
import { DocumentService } from './services/document.service';
import { DocumentTemplateCategoryService } from './services/document-template-category.service';
import { DocumentTemplateService } from './services/document-template.service';
import { PreDocumentService } from './services/pre-document.service';
import { FixDocumentService } from './services/fix-document.service';
import { CounselingService } from './services/counseling.service';
import { DocumentAiService } from './services/document-ai.service';
import { DocumentAiV2Service } from './services/document-ai-v-2.service';
import { InAppPurchaseService } from './services/in-app-purchase.service';
import { FcmService } from './services/fcm.service';
import { NonMemberService } from './services/non-member.service';
import { AutoIssuedCouponService } from './services/auto-issued-coupon.service';
import { AppleEventService } from './services/apple-event.service';
import { SecureService } from './services/secure.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    TossPaymentsService,
    LpInspectionService,
    TokenService,
    PointService,
    CenterLogService,
    CouponService,
    UserService,
    AdminService,
    OAuthService,
    GoogleService,
    KakaoService,
    NaverService,
    AppleService,
    StorageService,
    SettingService,
    UserProductService,
    ProductService,
    ProductCategoryService,
    ShoppingCartService,
    ProductPurchaseService,
    AbnormalPaymentService,
    HealthCheckService,
    InfoService,
    VoucherService,
    EnrollmentService,
    TicketService,
    TicketTypeService,
    TicketSubsidyService,
    UserActionLogService,
    GuardianService,
    NotificationService,
    CenterTransactionService,
    CenterSalaryService,
    CenterService,
    CenterUserService,
    CenterRoleService,
    CenterGroupService,
    CenterNoticeService,
    CenterStatService,
    CenterInviteLogService,
    SubscribeService,
    OrderService,
    ChildService,
    ChildMemoService,
    CenterChildService,
    LogService,
    CenterJoinLogService,
    InquiryService,
    FaqService,
    ParentProfileService,
    ExcelService,
    LpInspectionCouponService,
    NoticeService,
    AdService,
    AppVersionService,
    MemoService,
    DevelopmentStageService,
    DiaryService,
    EnrollmentScheduleService,
    EnrollmentScheduleGroupService,
    AllScheduleService,
    ScheduleLogService,
    ScheduleService,
    KeywordService,
    TagService,
    ContentService,
    ContentCategoryService,
    ContentFavoriteService,
    UrlService,
    PopupService,
    InspectionDataService,
    UserSettingService,
    GrowthCenterService,
    ReceiptService,
    DownloadProgressService,
    LpInspectionResultService,
    PaymentService,
    TeacherPaymentService,
    ParentPaymentService,
    RefundOrderService,
    KakaoTalkBizMessageService,
    PdfService,
    DocumentService,
    DocumentTemplateCategoryService,
    DocumentTemplateService,
    PreDocumentService,
    FixDocumentService,
    CounselingService,
    DocumentAiService,
    DocumentAiV2Service,
    InAppPurchaseService,
    FcmService,
    NonMemberService,
    AutoIssuedCouponService,
    AppleEventService,
    SecureService,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
